import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { getDataFromResponse } from '../constant/utils/react-query-utils/getDataFromResponse';
import { setApiError } from '../store/slices/apiError.slice';
import { ErrorSource } from '../constant/model/api/api';
import { handleApiError } from '../constant/utils/error.helper';
import { getMemberDemographics } from '../api/user.api';
import {
  updateGenderOptions,
  updatePronounOptions,
  updateEthnicityOptions,
  updateSexualOrientationOptions
} from '../store/slices/demographic.slice';
import { demographicKeys } from '../constant/query-keys/demographicKeys';

export const useMemberDemographicsQuery = () => {
  const dispatch = useDispatch();
  
  return useQuery(
    demographicKeys.lists(),
    async () => {
      const response = await getMemberDemographics();
      const data = getDataFromResponse(response);
      if (data.statusCode && data.statusCode !== 200) {
        const error = new Error('Demographics request failed') as any;
        error.response = {
          data: data,
          status: data.statusCode,
        };
        throw error;
      }
      
      return data;
    },
    {
      onSuccess: (data) => {
        dispatch(updateGenderOptions(data.data.genderOptions));
        dispatch(updatePronounOptions(data.data.pronounOptions));
        dispatch(updateEthnicityOptions(data.data.ethnicityOptions));
        dispatch(updateSexualOrientationOptions(data.data.sexualOrientationOptions));
      },
      onError: (error) => {
        const errorDetails = handleApiError(error);
        dispatch(setApiError({
          source: ErrorSource.DEMOGRAPHICS,
          error: {
            message: errorDetails.message || 'Failed to fetch demographics',
            statusCode: errorDetails.status || 500,
            stack: errorDetails.stack || ''
          }
        }));
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );
};